import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSecurity } from '../../Contexts/SecurityContext';

const PermissionRoute = ({ permission, anyOf }) => {
    const location = useLocation();
    const { hasPermission, hasAnyPermission } = useSecurity();
    const allowed = permission ? hasPermission(permission) : hasAnyPermission(anyOf);

    return allowed
        ? <Outlet />
        : (
            <Navigate
                to="/access-denied"
                replace
                state={{ reason: 'permission_required', from: location.pathname }}
            />
        );
};

export default PermissionRoute;
